import HeartFill from './HeartFill'

export default HeartFill
// eslint-disable-next-line import/export
export * from './HeartFill'
